import React from 'react';
import UDIDropdownfield from "./UDIDropdownfield.js"

const IssuingEntityDirectMarkingDI = ({
	UDI,
	setUDI,
	forceIsEditing = null
}) => {

	const fieldName = "IssuingEntityDirectMarkingDI";
	const fieldTitle = "Issuing Entity Direct Marking DI";
	const LOV = [

		{ key: "", value: "" },
		{ key: "GS1", value: "GS1" },
        { key: "HIBCC", value: "HIBCC" },
        { key: "ICCBBA", value: "ICCBBA" },
        { key: "IFA", value: "IFA" },
        { key: "EUDAMED", value: "EUDAMED" },

	];

	return <>
		<UDIDropdownfield UDI={UDI} setUDI={setUDI} fieldTitle={fieldTitle} fieldName={fieldName} LOV={LOV} forceIsEditing={forceIsEditing} />
	</>											  
}


export default IssuingEntityDirectMarkingDI;


